import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Linkedin, Instagram, Youtube } from 'lucide-react';

const socials = [
  { icon: Linkedin, href: 'https://www.linkedin.com/in/dawid-st', label: 'LinkedIn Dawida' },
  { icon: Instagram, href: 'https://www.instagram.com/_stepiendawid/', label: 'Instagram Dawida' },
  { icon: Youtube, href: 'https://www.youtube.com/@DAIEN-d', label: 'YouTube DAIEN' },
];

export default function AboutSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="about" aria-label="O mnie" className="py-20 md:py-32 bg-bg">
      <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="grid gap-10 md:gap-12 lg:gap-16 md:grid-cols-[280px_1fr] lg:grid-cols-[320px_1fr] items-start"
        >
          {/* Lewa kolumna: chip + zdjęcie (sticky na desktop) */}
          <div className="md:sticky md:top-24 text-center md:text-left">
            <span className="inline-flex bg-accent-from/20 text-accent-to px-4 py-1.5 rounded-full text-xs font-medium uppercase tracking-wider mb-6">
              Kto to buduje
            </span>
            <div className="w-full max-w-[280px] lg:max-w-[320px] aspect-square rounded-2xl overflow-hidden border border-stroke mx-auto md:mx-0">
              <img
                src="/images/dawid-v2.webp"
                alt="Dawid Stępień - DAIEN"
                className="w-full h-full object-cover"
                loading="lazy"
                width="520"
                height="520"
              />
            </div>

            {/* Linki social - wiarygodnosc */}
            <div className="flex items-center gap-3 mt-4 justify-center md:justify-start">
              {socials.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="w-10 h-10 rounded-full bg-surface border border-stroke flex items-center justify-center text-muted hover:text-text-primary hover:border-accent-to transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Prawa kolumna: tytuł, sub, paragrafy */}
          <div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl tracking-tight font-light text-text-primary mb-4 text-center md:text-left">
              Dawid Stępień
            </h2>

            <p className="text-2xl md:text-3xl text-accent-to font-light leading-snug mb-10 md:mb-12">
              Pomagam firmom oszczędzić <span className="font-medium">pieniądze i czas</span> przez technologię.
            </p>

            <div className="space-y-6 text-muted leading-relaxed text-lg">
              <p>
                Cześć, widzę, że albo (A) zgubiłeś się w internecie, albo (B) potrzebujesz rozwiązań dla swojej firmy.
                Hahaha. Jeśli plan B, to bardzo dobrze trafiłeś. Nazywam się Dawid Stępień i zajmuję się tego typu
                rozwiązaniami dla firm.
              </p>

              <p>
                Jestem ex-inżynierem energetyki i pracowałem w mojej pierwszej miłości :( czyli automatyce
                zabezpieczeniowej EAZ. (Spoko, sam nie wiedziałem co to znaczy na samym początku, ale mało
                ważne...) W międzyczasie ze swoją nową miłością, czyli AI, zacząłem się dobrze zapoznawać
                i stwierdziłem, że jak mi z nią dobrze, to polecę innym.
              </p>

              <p>
                Technologia rozwija się w tempie niesamowicie szybkim i rozumiem, jakie jest przytłoczenie ilością
                tego. Więc jestem tym, który Ci doradzi w Twojej firmie usługowej lub e-commerce, co można zastosować
                lub jak pozyskać nowych klientów.
              </p>

              <p>
                Przez to, że miłość jest długoterminowa, przez ten czas zdobyłem długoterminowe znajomości i mam
                nadzieję, że i Ty będziesz chciał współpracować i zbudować coś niesamowitego :).
              </p>

              <p>
                Po tym dosyć nudnym wstępie zapraszam Cię do kontaktu. Zobaczymy, co można dla Ciebie zrobić.
                Do zobaczenia po drugiej stronie.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
